import {
    getNotificationSubscription,
    listNotificationSubscriptions
} from './queries';
import {
    createNotificationSubscription,
    deleteNotificationSubscription,
    updateNotificationSubscription,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';

import {
    CreateNotificationSubscription,
    DeleteNotificationSubscription,
    GetNotificationSubscription,
    ListNotificationSubscriptions,
    NotificationSubscription,
    UpdateNotificationSubscription
} from "../types.ts";
import {
    notifySuccess,
    showErrorNotifications,
} from "../../../components/ServiceNotifications.tsx";
import {generateClient} from "aws-amplify/api";
import {stripReadonlyFields} from '../../../utils/stripReadonlyFields';


const region = 'us-east-1';


const client = generateClient();


export const fetchRecords = async (query: { topicArn?: string, nextToken?: string | null, limit?: number }) => {

    const variables: Record<string, unknown> = {
        region: region,
    };

    if (query.topicArn) {
        variables.topicArn = query.topicArn;
    }
    if (query.nextToken) {
        variables.nextToken = query.nextToken;
    }
    if (query.limit) {
        variables.limit = query.limit;
    }

    try {
        const response = await client.graphql<GraphQLQuery<ListNotificationSubscriptions>>({
            query: listNotificationSubscriptions,
            variables: variables
        });

        return {
            items: response.data?.listSubscriptions.items as NotificationSubscription[],
            nextToken: response.data?.listSubscriptions.nextToken,
        };
    } catch (e) {
        showErrorNotifications(e);
    }
};

export const fetch = async (subscriptionArn: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<GetNotificationSubscription>>({
            query: getNotificationSubscription,
            variables: {
                region: region,
                subscriptionArn: subscriptionArn
            },
        });
        return response.data?.getSubscription;
    } catch (e) {
        showErrorNotifications(e);
    }
};

export const add = async (payload: object) => {
    try {
        const response = await client.graphql<GraphQLQuery<CreateNotificationSubscription>>({
            query: createNotificationSubscription,
            variables: {
                region: region,
                input: payload
            },
        });
        notifySuccess('Subscription created');
        return response.data?.createSubscription;
    } catch (e) {
        showErrorNotifications(e);
    }
};

export const update = async (_id: string, record: NotificationSubscription) => {
    const payload = stripReadonlyFields(record);
    try {
        const response = await client.graphql<GraphQLQuery<UpdateNotificationSubscription>>({
            query: (updateNotificationSubscription),
            variables: {
                region: region,
                input: payload
            },
        });
        notifySuccess('Subscription updated');
        return response.data?.updateSubscription;
    } catch (e) {
        showErrorNotifications(e);
    }
};

export const deleteRecord = async (subscriptionArn: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<DeleteNotificationSubscription>>({
            query: (deleteNotificationSubscription),
            variables: {
                region: region,
                input: {
                    subscriptionArn: subscriptionArn
                }
            },
        });
        notifySuccess('Subscription deleted');
        return response.data?.deleteSubscription;
    } catch (e) {
        showErrorNotifications(e);
    }
};
